    <table class="table table-centered mb-0">
      <thead class="table-dark">
        <tr>
          <th>Article</th>
          <th>Unit of measurement</th>
          <th>Quantity</th>
          <th>Price per unit</th>
        </tr>
      </thead>
      <tbody>
        @for(article of articles; track article.name) {
            <tr>
                <td>{{article.name}}</td>
                <td>{{article.unitOfMeasurement}}</td>
                <td>{{article.quantity}}</td>
                <td>{{article.price}}</td>
              </tr>
        }
      </tbody>
    </table>
